
import { Component, Vue } from 'vue-property-decorator';
import OsAlertBox from '@/components/core/OsAlertBox.vue';
@Component({
  components: { OsAlertBox }
})
export default class OsSurveyStepIntroInfo extends Vue {}
